import { Span } from '@sanardigital/monitoring-wrapper'

const hasNewRelicOnEnvironment = () => window.newrelic !== undefined
const span = Span.create()

export const setNewrelicUser = ({ email = '' }) => {
    if (hasNewRelicOnEnvironment()) {
        window.newrelic.setCustomAttribute('userEmail', email)
    }
}

export const logError = (error: any, extras = {}) => {
    if (hasNewRelicOnEnvironment()) {
        window.newrelic.noticeError(error, extras)
        span.emit({
            message: error,
            type: 'ERROR',
            attributes: extras,
        })
    } else {
        console.error(error, extras)
    }
}
